import { render } from "./DbsReports.vue?vue&type=template&id=4cb206dd"
import script from "./DbsReports.vue?vue&type=script&lang=js"
export * from "./DbsReports.vue?vue&type=script&lang=js"

import "./DbsReports.vue?vue&type=style&index=0&id=4cb206dd&lang=scss"
script.render = render

export default script